import { useEffect, useState } from 'react'

import { useSubscription } from '../../../hooks/useSubscription'

type Params = {
  onSuccess: () => void
  onError?: () => void
}

export const useProcessing = ({ onSuccess, onError }: Params) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const { activeSubscription, pendingSubscription } = useSubscription()
  const [localPendingSubscriptionId, setLocalPendingSubscriptionId] = useState<string | null>(null)

  useEffect(() => {
    if (pendingSubscription) {
      setLocalPendingSubscriptionId(pendingSubscription.id)
    }
  }, [pendingSubscription])

  useEffect(() => {
    if (!isProcessing || !localPendingSubscriptionId || !activeSubscription || pendingSubscription)
      return

    if (activeSubscription.id === localPendingSubscriptionId) {
      onSuccess()
      setIsProcessing(false)
    } else {
      onError?.()
      setIsProcessing(false)
      setLocalPendingSubscriptionId(null)
    }
  }, [
    activeSubscription,
    isProcessing,
    localPendingSubscriptionId,
    onError,
    onSuccess,
    pendingSubscription,
  ])

  return {
    isProcessing,
    setIsProcessing,
  }
}
